"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
var componentChildCount = function componentChildCount(element) {
    return react_1.default.Children.toArray(element.props.children).length;
};
exports.default = componentChildCount;
